<template>
  <div class="GlobalTable">
    <div class="table_static">
      <div class="ts_left">
        <div class="blueLine"></div>
        <span>合计：</span>
        <p>总入账：<span style="color: #80C269;">{{ totalInNums || 0 }}笔</span>&nbsp;<span style="color: #80C269;">{{ totalInBalance || 0 }}元</span></p>
        <p>总出账：<span style="color:red;">{{ totalOutNums|| 0 }}笔</span>&nbsp;<span style="color:red;">{{ totalOutBalance || 0 }}元</span></p>
        <p>净入账：<span style="color: #80C269;">{{ netAmountReceived || 0 }}元</span></p>
      </div>
      <!-- <div>
        <el-button icon="el-icon-download" slot="AddSlot" type="success" :loading="exportLoading" @click="exportBill" size="small">导出账单</el-button>
      </div> -->
    </div>
    <GlobalTable
      ref="GlobalTable"
      v-loading="loading"
      :columns="tableColumns"
      :data="seachDataList"
      :currentPage="page.pageNum"
      :total="page.total"
      @handleCurrentChange="handleCurrentChange"
    >
      <el-table-column label="流水号" slot="uniqNo" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.uniqNo || "--" }}</span>
        </template>
      </el-table-column>
        <el-table-column label="关联订单号" slot="orderNo" align="center">
        <template slot-scope="{ row }">
          <div style="color: #0981ff;cursor: pointer;" 
                @click="toOrderDetails(row)">
                <span style="border-bottom: 1px solid #0981ff">{{ row.orderNo }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="撮合渠道" slot="matchChannelName" align="center">
            <template slot-scope="{ row }">
              <div>{{ row.matchChannelName || "--" }}</div>
            </template>
          </el-table-column>
      <el-table-column label="回收商" slot="merchantName" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.merchantName || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="门店商户" slot="companyName" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.companyName || "--" }}</span>
            </template>
      </el-table-column>
            <!-- <el-table-column label="订单状态" slot="orderStatus" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.merchantName || "--" }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="账单类型" slot="opt" align="center">
        <template slot-scope="{ row }">
          <span>{{
            row.opt == "01" ?  "入账" : "出账"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="子类型" slot="typeCode" align="center">
        <template slot-scope="{ row }">
          <div>
            {{
              row.title || "--"
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="金额" slot="amount" align="center">
        <template slot-scope="{ row }">
          <span
            :style="row.opt == '01' ? 'color:green' : 'color:red'"
            >{{
              row.opt == "01"
                ? `+${row.amount}`
                : `-${row.amount}`
            }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="账户结余" slot="nowBalance" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.afterBalance || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="备注" width="130rpx" slot="remark" align="center">
        <template slot-scope="{ row }">
          <el-tooltip
            class="item"
            effect="dark"
            :content="row.remark"
            placement="top"
          >
            <div class="Remarks">
              {{ row.remark || "--" }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
    </GlobalTable>
  </div>
</template>

<script>
import _api from "@/utils/request";
export default {
  name: "Table",
  props: {},
  data() {
    return {
      amountPrice: 0,
      netIncome: '',
      loading: false,
      seachDataList: [],
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      pageNum: 1,
      tableColumns: [
        { slotName: "uniqNo" },
        {slotName:"orderNo"},
        {slotName:"matchChannelName"},
        { slotName: "merchantName" },
        { slotName: "companyName" },
        // {slotName:"orderStatus"},
        // { label: "订单成交时间", prop: "orderTime" },
        { label: "账单时间", prop: "createTime" },
        {label:'费用类目',prop:"accountName"},
        { slotName: "opt" },
        { slotName: "typeCode" },
        { slotName: "storeName" },
        { slotName: "amount" },
        { slotName: "nowBalance" },
        { slotName: "remark" },
      ],
      exportLoading: false,
      totalInNums:"",
      totalInBalance:'',
      totalOutNums:"",
      totalOutBalance:"",
      netAmountReceived:""
    };
  },
  created() {
    this.handleCurrentChange();
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams;
    },
  },
  watch: {
    SeachParams(newVal) {
      console.log(newVal);
      this.handleCurrentChange();
    },
  },
  methods: {
    // 表格切换页面
    handleCurrentChange(val) {
      if (val) {
        this.pageNum = val;
        this.page.pageNum = val;
      } else {
        this.page.pageNum = 1;
      }
      const baseRequest = {
        merchantId: this.SeachParams.merchantId,
        opt: this.SeachParams.opt,
        startTime: this.SeachParams.startTime,
        endTime: this.SeachParams.endTime,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        serType: this.SeachParams.serType,
        orderNo:this.SeachParams.orderNo,
        accountNo:this.SeachParams.priceType,
        companyId:this.SeachParams.companyId||"",
      };
      this.loading = true;
      _api
        .getMatchChannelList(baseRequest)
        .then((res) => {
          console.log(res);
          if (res.code === 1) {
            this.seachDataList = res.data.ipage.records;
            this.page.total = res.data.ipage.total;
            this.page.pageNum = res.data.ipage.current;
          this.totalInNums=res.data.totalInNums
          this.totalInBalance=res.data.totalInBalance
          this.totalOutNums=res.data.totalOutNums
          this.totalOutBalance=res.data.totalOutBalance
          this.netAmountReceived=res.data.netAmountReceived
            this.loading = false;
          }
        })
        .finally(() => {
          this.loading = false;
          if (typeof this.SeachParams.disuseLoding == "function") {
            this.SeachParams.disuseLoding();
          }
        });
    },
    toOrderDetails(row) {
      this.$router.push({
        path: "/profitSplit/orderDetails",
        query: { type: "edit", id: row.orderNo },
      });
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.amount-price {
  color: #f59a23;
  font-size: 14px;
  margin: 15px 0;
  display: flex;
  align-items: center;
  .unit {
    color: #666666;
    margin: 0 5px 0;
  }
  .amount-box {
    width: 40px;
    height: 40px;
    background-color: #f5f7fa;
    color: #f59a23;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.sure-tip {
  color: #0981ff;
  font-size: 16px;
  padding-left: 10px;
  border-left: 3px solid;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.GlobalTable {
  // 备注说明
  .Remarks {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //控制行数
    overflow: hidden;
  }

  .operation-btn {
    /deep/.el-button {
      margin-left: 0;
    }
  }
}
.table_static {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ts_left {
  display: flex;
  align-items: center;
  p {
    margin-left: 30px;
  }
}
.blueLine {
  margin-right: 10px;
  width: 4px;
  height: 24px;
  background: #4c84ff;
  border-radius: 2px;
  background-color: #0981ff;
}
</style>
